export class CurrencyInfo {
  #code = '';
  #symbol = '?';

  constructor(code, symbol) {
    this.#code = code;
    this.#symbol = symbol;
  }

  get code() {
    return this.#code;
  }

  get symbol() {
    return this.#symbol;
  }

  static fromJson(json) {
    return new CurrencyInfo(json.code, json.symbol);
  }

  static fromCode(code) {
    return new CurrencyInfo(
      code,
      window.currencyConfig.currencySymbols[code] ?? window.currencyConfig.defaultCurrencySymbol
    );
  }
}
